<div
  class="hold-container fx-column fx-align-center fx-justify-center"
  [class.hold-container-enabled]="enabled()"
>
  @if (!isImageAvailable && !isVideoAvailable) { @if (videoReady()) {
  <app-freeze-frame
    class="frame"
    [stream]="stream"
    [local]="true"
    [mirror]="true"
    [render]="enabled()"
  >
  </app-freeze-frame>
  } } @if (enabled()) { @if (isImageAvailable) {
  <img
    [src]="imageSrc"
    alt="{{ 'Your call is on hold' | translate }}"
    class="frame"
    (error)="imgLoadFailed($event)"
  />
  } @if (isVideoAvailable) {
  <video
    #videoRef
    class="frame"
    preload="auto"
    autoplay
    playsinline
    webkit-playsinline="true"
    loop
    (canplaythrough)="canPlayThrough($event)"
  >
    <source [src]="videoSrc" />
  </video>
  } }

  <div
    class="container"
    role="alert"
    [attr.aria-label]="'Your call is on hold' | translate"
  >
    <av-icon name="pause" class="icon-hold"></av-icon>
    <h1 aria-hidden="true" translate>Your call is on hold</h1>
    <h2 class="blink" translate>Please wait</h2>
  </div>
</div>
